module.exports = __webpack_public_path__ + "static/media/file.6ba4ec7a.png";